import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalPreviewMessageHistory } from "./constants";
import type {
  ConversationalPreviewMessageHistoryResult,
  GetConversationalPreviewMessageHistoryProps,
} from "./types";
import { isConversationalPreviewMessageHistoryResult } from "./validators";

/**
 * The messages already exchanged with a Braze user on an SMS or WhatsApp subscription group, which a settings
 * preview on that group gives the agent as context. Requires the PII-viewing permission on top of the preview
 * permissions, since the messages are end-user content.
 */
export const getConversationalPreviewMessageHistory = reactQueryFetcherAdapter(
  conversationalPreviewMessageHistory,
  (
    signal: AbortSignal,
    { appGroupId, userId, subscriptionGroupId }: GetConversationalPreviewMessageHistoryProps
  ): Promise<ConversationalPreviewMessageHistoryResult> => {
    return fetch(
      `/${appGroupId}/conversational/preview_message_history`,
      "GET",
      { user_id: userId, subscription_group_id: subscriptionGroupId },
      { signal }
    );
  },
  isConversationalPreviewMessageHistoryResult
);
